<div class="row section-row" [formGroupName]="formControlName">
  <div class="col section-col">
    <h5 class="section-heading">Duty of Candour</h5>
  </div>
</div>
<app-capture-details [parentFormGroup]="formGroup"></app-capture-details>
<div class="row section-row">
  <div class="col-12 section-col">
    <app-date
      formElementId="dateOfMeeting"
      label="Date of Duty of Candour Meeting?"
      [parentFormGroup]="formGroup"
    >
    </app-date>
  </div>
</div>
<div class="row section-row">
  <div class="col-12 section-col">
    <app-file-upload
      [accessionNumber]="accessionNumber"
      [id]="formElementModels['copyOfSiReport'].id"
      [formElementModel]="formElementModels['copyOfSiReport']"
      [parentFormGroup]="formGroup"
    ></app-file-upload>
  </div>
</div>
<div class="row section-row">
  <div class="col-12 section-col">
    <app-rich-text-editor
      [id]="formElementModels['supportFromEverlight'].id"
      [formElementModel]="formElementModels['supportFromEverlight']"
      [parentFormGroup]="formGroup"
    ></app-rich-text-editor>
  </div>
</div>
<div class="row section-row">
  <div class="col-12 section-col">
    <app-rich-text-editor
      [id]="formElementModels['lessonsLearnt'].id"
      [formElementModel]="formElementModels['lessonsLearnt']"
      [parentFormGroup]="formGroup"
    ></app-rich-text-editor>
  </div>
</div>
